import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useMemo } from 'react';

type Props = {
  editorState: string;
};

export const EditorStateUpdatePlugin: React.FunctionComponent<Props> = (props) => {
  const { editorState } = props;
  const [editor] = useLexicalComposerContext();

  const editorIsMountedRef = useMemo(
    () => ({ current: false }),
    [editor], // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(
    () => {
      if (!editorIsMountedRef.current) {
        return;
      }
      editor.setEditorState(editor.parseEditorState(editorState));
    },
    [editor, editorState], // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(
    () => {
      editorIsMountedRef.current = true;
    },
    [editor], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return null;
};
